import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function DirectOfferSection() {
  return <section id="offer" className="w-full bg-navy py-14 md:py-[88px] px-6" data-id="element-45">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-[540px] mx-auto text-center mb-8" data-id="element-46">
        <p className="text-lg font-sans italic text-[#C8D8E8]" data-id="element-47">
          Una sola decisión. La mesa está puesta. Solo falta que te sientes.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[540px] mx-auto bg-white rounded-[16px] p-8 md:py-[52px] md:px-[48px] shadow-[0_8px_48px_rgba(0,0,0,0.15)] flex flex-col items-center text-center" data-id="element-48">
        <img src="https://cdn.magicpatterns.com/uploads/x2nzayb2UHKhHp3bLB4ACT/Imegen_Ebook_-_Marta,_Don_Raul_y_La_Inteligencia_Artificial-A.png" alt="Marta, Don Raúl y la Inteligencia Artificial - Bundle" className="w-full max-w-[320px] h-auto object-contain mb-6 -mt-2" data-id="element-49" />

        <span className="font-sans font-bold text-[11px] text-gold uppercase tracking-wider" data-id="element-50">
          PRECIO ESPECIAL DE LANZAMIENTO
        </span>

        <h2 className="text-[26px] font-serif font-bold text-navy mt-2 leading-[1.3]" data-id="element-51">
          Marta, Don Raúl y la
          <br data-id="element-52" />
          Inteligencia Artificial
        </h2>

        <p className="text-[14px] font-sans text-[#666666] mt-2" data-id="element-53">
          Ebook Digital en PDF &middot; Descarga Inmediata &middot; Acceso de
          por vida &middot; 121 páginas &middot; 6 historias reales
        </p>

        <div className="flex items-baseline justify-center mt-4" data-id="element-54">
          <span className="text-[56px] font-serif font-bold text-navy leading-none" data-id="element-55">
            $12.97
          </span>
        </div>

        <p className="text-[13px] font-sans text-[#888888] mt-1" data-id="element-56">
          Pago único. Sin renovaciones. Sin suscripciones.
        </p>

        <motion.a href="https://godeskcore.com/cart/42976931151920:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
        scale: 1.02,
        filter: 'brightness(0.92)'
      }} whileTap={{
        scale: 0.98
      }} className="w-full mt-7 bg-burnt text-white font-sans font-bold text-[17px] py-5 rounded-lg shadow-[0_4px_20px_rgba(230,126,34,0.4)] transition-all duration-200 block text-center no-underline" data-id="element-57">
          Descargar mi copia ahora &rarr;
        </motion.a>

        <p className="text-[11px] font-sans text-[#888888] mt-3" data-id="element-58">
          Compra 100% segura &middot; Acceso inmediato al PDF &middot; Si no te
          cambia la perspectiva, te devolvemos el dinero. Sin preguntas.
        </p>

        <div className="flex items-center justify-center gap-2 mt-5 text-xs font-sans text-[#888888]" data-id="element-59">
          <span data-id="element-60">🔒 Pago Seguro</span>
          <span data-id="element-61">&middot;</span>
          <span data-id="element-62">📄 PDF Inmediato</span>
          <span data-id="element-63">&middot;</span>
          <span data-id="element-64">↩ Garantía Total</span>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="max-w-[540px] mx-auto mt-10 bg-crema/10 border border-[#D4AF37]/30 rounded-xl px-8 py-6 text-center" data-id="element-65">
        <p className="text-[14px] font-sans italic text-[#C8D8E8] leading-[1.85]" data-id="element-66">
          <span className="font-bold not-italic text-gold" data-id="element-67">
            Nota de Roderic:
          </span>{' '}
          Mantendré este precio solo mientras recolectamos las primeras
          historias de éxito. Una vez alcanzada la meta, el precio cambiará.
        </p>
      </motion.div>
    </section>;
}